/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import * as React from 'react';
import { IMachineIdentification, LocalizedText } from '@umati/dashboard-types';
import SectionData from '../simpleComponents/SectionData';
import { labels } from '../labels/Labels';

const nestedValueOrSelf = (obj: { Value?: any } | undefined | string | number | boolean | null | LocalizedText) => {
  if (obj && typeof obj === 'object' && 'Value' in obj) {
    return obj.Value ?? obj;
  }
  return obj;
};

export default function Identification(props: IMachineIdentification) {
  const colStyle = 'col-12 col-sm-6 col-md-4';
  const manufacturer = nestedValueOrSelf(props.Manufacturer);
  const productInstanceUri = nestedValueOrSelf(props.ProductInstanceUri);
  const yearOfConstruction = nestedValueOrSelf(props.YearOfConstruction);
  const serialNumber = nestedValueOrSelf(props.SerialNumber);
  const softwareRevision = nestedValueOrSelf(props.SoftwareRevision);
  const deviceClass = nestedValueOrSelf(props.DeviceClass);
  const location = nestedValueOrSelf(props.Location);
  const model = nestedValueOrSelf(props.Model);
  const productCode = nestedValueOrSelf(props.ProductCode);

  return (
    <div className="section">
      <div className="row">
        {manufacturer && (
          <SectionData cols={colStyle} label={labels.manufacturer} value={manufacturer?.text || manufacturer} />
        )}
        {productInstanceUri && (
          <SectionData cols={colStyle} label={labels.productUri} value={productInstanceUri} tryRenderAsLink={true} />
        )}
        {serialNumber && <SectionData cols={colStyle} label={labels.serialNumber} value={serialNumber} />}
        {softwareRevision && <SectionData cols={colStyle} label={labels.softwareVersion} value={softwareRevision} />}
        {yearOfConstruction && <SectionData cols={colStyle} label={labels.buildYear} value={yearOfConstruction} />}
        {deviceClass && <SectionData cols={colStyle} label={labels.deviceClass} value={deviceClass} />}
        {location && <SectionData cols={colStyle} label={labels.location} value={location} />}
        {model && <SectionData cols={colStyle} label={labels.model} value={model?.text || model} />}
        {productCode && <SectionData cols={colStyle} label={labels.productCode} value={productCode} />}
      </div>
    </div>
  );
}
